export default "__VITE_ASSET__yHLD7sgi__"